

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import TimelineItem from "examples/Timeline/TimelineItem";

const index = (data) => {

    try {
        let terfiRows = data.data.terfiler.map(terfi => (
            <TimelineItem
                key={terfi.id}
                color={terfi.terfi_tenzil === "Terfi" ? "success" : "error"}
                icon={terfi.terfi_tenzil === "Terfi" ? "unarchive" : "archive"}
                description={`Eski Unvan: ${terfi.eski_rutbe}`}
                title={`${terfi.yeni_rutbe} (${terfi.ilgili_bolum})`}
                dateTime={terfi.degisiklik_tarihi}
            />
        ));



        return (
            <Grid item xs={12} md={6} xl={6}>
                <Card className="h-100">
                    <SoftBox pt={3} px={3}>
                        <SoftTypography variant="h6" fontWeight="medium">
                            Terfi geçmişi
                        </SoftTypography>
                        <SoftBox mt={1} mb={2}>
                            <SoftTypography variant="button" color="text" fontWeight="regular">
                                <SoftTypography display="inline" variant="body2" verticalAlign="middle">
                                    <Icon sx={{ fontWeight: "bold", color: ({ palette: { success } }) => success.main }}>
                                        arrow_upward
                                    </Icon>
                                </SoftTypography>
                                &nbsp;
                                <SoftTypography variant="button" color="text" fontWeight="medium">
                                    {terfiRows.length}
                                </SoftTypography>{" "}
                                Terfi Güncellemesi
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                    <SoftBox p={2}>
                        {terfiRows}
                    </SoftBox>
                </Card>
            </Grid>
        );
    }
    catch (error) {
        return(
        <Grid item xs={12} md={12} xl={12}>
            <SoftBox pt={3} px={3}>
                <SoftTypography variant="h2" fontWeight="medium">
                    Yetkilendirilmemiş Giriş
                </SoftTypography>
            </SoftBox>
        </Grid>
        );
    }
}

export default index;
